/** @jsxRuntime classic */
/** @jsx jsx */
import {css, jsx} from "@emotion/core";
import React from 'react';
import {
    Button,
    Container,
    Dialog,
    Dropdown, EditIcon,
    EllipsisHIcon,
    Menu,
    MenuItem,
    PlusCircleIcon, SearchIcon, Theme,
    Toolbar,
    ToolbarSpacer
} from "@ice/components";
import {getAppState} from "../store/AppState";
import {Dataset} from "../data/Dataset";
import {getAppComponent, getMapComponent} from "../store/Accessor";
import {AgGrid} from "@ice/ag-grid";
import {$t, $ts} from "../lang/LangUtil";
import {EditTextDialog} from "./EditTextDialog";
import {XIcon} from "../ui/XIcon";
import {IconInfo} from "../util/IconInfo";
import {GuiUtil} from "../util/GuiUtil";
import {QuestionDialog} from "./QuestionDialog";
import {AddLayerDialog} from "./AddLayerDialog";


interface DatasetListPanelProps {
}


interface DatasetListPanelState {
}


export default class DatasetListPanel extends React.Component<DatasetListPanelProps, DatasetListPanelState> {

    constructor(props: DatasetListPanelProps) {
        super(props);
        this.state = {}
    };

    private deleteDataset = (dataset: Dataset) => {
        const appComponent = getAppComponent();
        appComponent.showDialog(
            <QuestionDialog
                title={$t("confirm")}
                text={$ts("deletedatasetx", dataset.getName())}
                onConfirm={() => {
                    const appState = getAppState();
                    const mapComponent = getMapComponent();
                    const layerDefsToDelete = appState.getLayerDefs(dataset);
                    appState.deleteDataset(dataset);
                    this.forceUpdate();
                    for (const def of layerDefsToDelete) {
                        mapComponent.deleteLayer(def);
                    }
                    appComponent.hideDialog();
                }}
            />
        );
    }

    private renameDataset = (dataset: Dataset) => {
        getAppComponent().showDialog(
            <EditTextDialog title={$t("renamedataset")} value={dataset.getName()} confirmText={$t("rename")} onChange={name => {
                dataset.setName(name);
                let app = getAppComponent();
                app.hideDialog();
                app.refreshToolbox();
            }} />
        )
    }

    private showDataset = (dataset: Dataset) => {
        const closeDialog = () => getAppComponent().hideDialog();

        let fieldDefs = dataset.getFieldDefs();

        const gridFieldDefs = [{field: "rownum", headerName: "#", width: 50, filter: false, sortable: true}];
        let count = 0;
        for (const def of fieldDefs) {
            count++;
            gridFieldDefs.push({field: String(def.id), headerName: `[${count}] ${def.name}`, width: 120, filter: true, sortable: true});
        }
        const gridRowData = [];
        count = 0;
        for (const row of dataset.getDataRows()) {
            count++;
            const gridRow = {rownum: count};
            for (const def of fieldDefs) {
                gridRow[String(def.id)] = row.getValue(def.id);
            }
            gridRowData.push(gridRow);
        }

        const dialog = (
            <Dialog
                onClose={closeDialog}
                title={`Dataset: ${dataset.getName() ?? dataset.getId()}, Size: ${dataset.getSize()}`}
                closeControl={true}
                modal={true}
                closeOnEscapeKeyPress={false}
            >
                <div css={css`width: 80vw; height: 80vh;`}>
                    <AgGrid
                        columnDefs={gridFieldDefs}
                        rowData={gridRowData}
                        defaultColDef={{resizable: true}}
                        compact
                        style={{height:"100%"}}
                    />
                </div>
                <Container pad>
                    <Toolbar bordered={false}>
                        <ToolbarSpacer />
                        <Button onClick={closeDialog}>Close</Button>
                    </Toolbar>
                </Container>
            </Dialog>
        );

        getAppComponent().showDialog(dialog);
    }

    private renderDataset = (dataset: Dataset) => {
        const datasetName = dataset.getName() ?? dataset.getId() ?? "";
        return [
            <Toolbar
                minimal
                size="xsmall"
                key={dataset.getId()}
            >
                <Button
                    square
                    onClick={() => this.showDataset(dataset)}
                    className={"listitem"}
                    css={(theme: Theme) => css`
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      color: ${theme.focusAndAccentColor};
                      &:hover {
                        color: ${theme.selectionColor};
                      }
					`}
                >
                    <span onClick={() => {}}>
						{datasetName}
					</span>
                </Button>
                <ToolbarSpacer />
                {  GuiUtil.renderToolbarIcon( IconInfo.RENAME, $t("rename"), () => this.renameDataset(dataset) ) }
                {  GuiUtil.renderToolbarIcon( IconInfo.DELETE, $t("delete"), () => this.deleteDataset(dataset) ) }
            </Toolbar>,
        ];
    }

    render = () => {
        // @ts-ignore
        const wrapper = window?.gisjavawrapper as any;
        return (
            <Container css={css``}>
                <Container orientation="vertical">
                    {/*{*/}
                    {/*    wrapper &&*/}
                    {/*    <Toolbar minimal size="xsmall">*/}
                    {/*        <div>*/}
                    {/*            <Button size={"xsmall"} onClick={() => wrapper?.searchSymbols()}>*/}
                    {/*                <SearchIcon width="fixed" />*/}
                    {/*                {$t("searchsymbols")}*/}
                    {/*            </Button>*/}
                    {/*            <ToolbarSpacer />*/}
                    {/*        </div>*/}
                    {/*    </Toolbar>*/}
                    {/*}*/}
                    {  getAppState().getDatasets().map(dataset => this.renderDataset(dataset)) }
                </Container>
            </Container>
        );
    }

}
